<div class="modal-header">
  <h4 class="modal-title header-13">
    {{ configs.title }}
  </h4>
  <button
  type="button"
  class="accello-icon-btn"
  (mousedown)="isActive = true"
  (mouseup)="isActive = false"
  (mouseleave)="isActive = false"
  (click)="activeModal.dismiss('Cross click')"
>
  <img
    [src]="
      isActive
        ? 'assets/images/virtusa-icons/close-dark.svg'
        : 'assets/images/virtusa-icons/close.svg'
    "
    alt="Close"
  />
</button>
</div>

<div class="modal-body">
  <div class="w-100 d-flex flex-column gap-3">

    <div class="d-flex flex-column">
      <span class="label general-text-6 mb-1">
        User Story ID <span class="text-danger" *ngIf="!disableUserStoryFields">*</span>
        <span *ngIf="configs?.data?.isLoadingStoryIds" class="ms-2 spinner-border spinner-border-sm text-primary" role="status"></span>
      </span>
      <app-autocomplete-input
        [options]="configs?.data?.storyIds ?? []"
        [value]="storyId"
        [placeholder]="'Select user story ID'"
        [isPlain]="true"
        [required]="!disableUserStoryFields"
        [disabled]="disableUserStoryFields"
        (optionSelected)="getStoryId($event)"
      ></app-autocomplete-input>
    </div>

    <div class="d-flex flex-column">
      <span class="label general-text-6 mb-1">
        Story <span class="text-danger" *ngIf="!disableUserStoryFields">*</span>
      </span>
      <textarea
        class="form-control general-text-5"
        name="userStory"
        [required]="!disableUserStoryFields"
        [disabled]="disableUserStoryFields"
        [(ngModel)]="userStory"
        placeholder="Enter user story"
      ></textarea>
    </div>

    <div class="d-flex flex-column">
      <span class="label general-text-6 mb-1">Test Case ID <span class="text-danger">*</span></span>
      <input class="form-control general-text-5" name="testCaseId" required [(ngModel)]="testCaseId" placeholder="Enter test case ID"/>
    </div>

    <div class="d-flex flex-column">
      <span class="label general-text-6 mb-1">Test Type <span class="text-danger">*</span></span>
      <select class="form-control general-text-5" name="testCaseType" required [(ngModel)]="testCaseType">
        <option *ngFor="let type of testTypeOptions" [value]="type">{{ type }}</option>
      </select>
    </div>

    <div class="d-flex flex-column">
      <span class="label general-text-6 mb-1">Sub Type <span class="text-danger">*</span></span>
      <input
        class="form-control general-text-5"
        name="subType"
        required
        [(ngModel)]="subType"
        placeholder="Enter sub type"
      />
    </div>

    <div class="d-flex flex-column">
      <span class="label general-text-6 mb-1">Test Case Description <span class="text-danger">*</span></span>
      <textarea class="form-control general-text-5" name="description" required [(ngModel)]="description" placeholder="Enter Test Case Description"></textarea>
    </div>

    <div class="d-flex flex-column">
      <span class="label general-text-6 mb-1">Prerequisites <span class="text-danger">*</span></span>
      <textarea class="form-control" name="textPrequities" required [(ngModel)]="textPrequities" placeholder="Add prerequisites"></textarea>
    </div>

    <div class="d-flex flex-column">
      <span class="label general-text-6 mb-1">Test Steps <span class="text-danger">*</span></span>
      <textarea class="form-control" name="textSteps" required [(ngModel)]="textSteps" placeholder="Enter Test Steps"></textarea>
    </div>

    <div class="d-flex flex-column">
      <span class="label general-text-6 mb-1">Sanitized Test Steps</span>
      <textarea class="form-control" name="sanitizedTestSteps" [(ngModel)]="sanitizedTestSteps" placeholder="Enter Sanitized Test Steps"></textarea>
    </div>

    <div class="d-flex flex-column">
      <span class="label general-text-6 mb-1">Expected Result <span class="text-danger">*</span></span>
      <textarea class="form-control" name="textResult" required [(ngModel)]="textResult" placeholder="Enter Expected Result"></textarea>
    </div>

  </div>
</div>

<div class="modal-footer">
  <div class="d-flex justify-content-end">
    <button
      class="btn mx-2 btn-accello-secondary"
      [disabled]="isSubmitting"
      (click)="activeModal.dismiss('Cross click')"
    >
      Cancel
    </button>
    <button
      class="btn btn-accello-primary-light d-inline-flex align-items-center gap-2"
      (click)="add()"
      [disabled]="isSubmitting || !canSubmit"
    >
      <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      {{ isSubmitting ? (configs?.submittingText ?? 'Adding...') : (configs?.saveBtnText ?? 'Add') }}
    </button>
  </div>
</div>
